import * as loaders from "@lts/loaders/legacy/legacy-stlFileLoader";
export { loaders };
export default loaders;
